<template>
  <Section
    :id="id"
    :header="t('contacts.contacts', 1)"
    class="carrier-portal-contact-section"
    data-class="flex flex-column flex-gap-1"
  >
    <div class="contact" :aria-label="t('contacts.contacts', 1)">
      <LabeledIcon icon="pi pi-building" :label="contact.companyName ?? '-'" />
      <LabeledIcon icon="pi pi-user" :label="contact.name ?? '-'" />
      <LabeledIcon icon="pi pi-phone" :label="contact.phone ?? '-'" />
      <LabeledIcon icon="pi pi-envelope" :label="contact.email ?? '-'" />
    </div>
  </Section>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Contact } from '@/model';

import LabeledIcon from '@/components/ui/LabeledIcon.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  contact: {
    type: Object as PropType<Contact>,
    required: true,
  },
});
const { id, contact } = toRefs(props);

const { t } = useI18n();
</script>

<style>
.carrier-portal-contact-section {
  .contact {
    display: flex;
    flex-direction: column;
    gap: var(--sp-2);
  }
}
</style>
